module.exports = __webpack_public_path__ + "img/floor_f6_02.36ed6872.png";